import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role_title: "", org: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to DFTB26!");
      nav("/program");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FFFFFF]">
      <div className="w-full max-w-sm">
        <Link to="/program" className="flex flex-col items-center gap-3 mb-8">
          <img src="/dftb26-mark.png" alt="" className="h-20 w-20 object-contain" />
          <img src="/dftb26-logo-dark.png" alt="DFTB26 - Back to Basics" className="h-12 w-auto object-contain" />
        </Link>
        <h1 className="font-display text-3xl mb-1 text-center">Create account</h1>
        <p className="text-sm text-[#5a5a5a] mb-6 text-center">Glasgow, 22-24 June 2026.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" required value={form.name} onChange={update("name")} className="h-12 rounded-sm mt-1" data-testid="register-name-input" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required autoComplete="email" value={form.email} onChange={update("email")} className="h-12 rounded-sm mt-1" data-testid="register-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required autoComplete="new-password" minLength={6} value={form.password} onChange={update("password")} className="h-12 rounded-sm mt-1" data-testid="register-password-input" />
          </div>
          <div>
            <Label htmlFor="role_title">Role (e.g. Paediatric SpR)</Label>
            <Input id="role_title" value={form.role_title} onChange={update("role_title")} className="h-12 rounded-sm mt-1" data-testid="register-role-input" />
          </div>
          <div>
            <Label htmlFor="org">Organisation</Label>
            <Input id="org" value={form.org} onChange={update("org")} className="h-12 rounded-sm mt-1" data-testid="register-org-input" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full h-12 rounded-sm bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24] font-semibold">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="text-sm text-[#5a5a5a] text-center mt-6">
          Already have one?{" "}
          <Link to="/login" className="text-[#000000] hover:underline" data-testid="register-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
